import { Component } from '@angular/core';
import { GeneralService } from './services/general.service';
import { Router } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent {
  
  // Observable que emite true si estás logado
  isAuthenticated$: Observable<boolean>;

  constructor(
    public generalService: GeneralService,
    private _router: Router,
    private oidc: OidcSecurityService
  ) {

    if (!environment.securityEnabled) {
      this.isAuthenticated$ = of(true);
    } else {
      this.isAuthenticated$ = this.oidc.checkAuth().pipe(
        map(auth => auth.isAuthenticated)
      );
    }
  }
}

